import { Injectable } from '@angular/core';
import { databases, ID, storage } from '../config/appwrite';
import { environment } from '../../../environments/environment';
import { Query } from 'appwrite';
import { Paciente,  PacienteUpdateFields } from '../models';

@Injectable({
  providedIn: 'root'
})
export class PacientesService {
  private collectionId = "pacientes";
  private DATABASE_NAME = environment.databaseName;

  constructor() { }


  /**
   *getPacientes
   * @returns
   */
  getData(): Promise<Paciente[]> {
    return databases.listDocuments<Paciente>(
      this.DATABASE_NAME,
      this.collectionId,
      [
        Query.limit(10000)
      ]
    ).then(response => response.documents);
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data: Paciente) {
    return databases.createDocument(this.DATABASE_NAME, this.collectionId, ID.unique(), data);
  }

  /**
   * @updateDocument()
   * @param idDocument
   * @param data
   * @returns
   */
  updateDocument_ORG(idDocument: string, data: Paciente) {
    data.$databaseId = undefined;
    data.$collectionId = undefined;
    return databases.updateDocument(this.DATABASE_NAME, this.collectionId, idDocument, data);
  }
  // En tu servicio, ajusta la firma del método updateDocument
// SE ADICIONAR AL MODELO PARCIAL
  updateDocument(idDocument: string, data: Partial<PacienteUpdateFields>) {
    data.$databaseId = undefined;
    data.$collectionId = undefined;
    return databases.updateDocument(this.DATABASE_NAME, this.collectionId, idDocument, data);
  
  }




  /**
   * @uploadFile
   * @param file
   * @returns
   */


  /**
   * @getDocument()
   * @param idDocument
   * @returns
   */
  getDocument(idDocument: string) {
    return databases.getDocument(this.DATABASE_NAME, this.collectionId, idDocument);
  }

  // Metodo para obtner solo los datos necesarios de la db
  getDocumentMinimal(idDocument: string): Promise<{
    $id: string;
    nombres: string;
    apellidos: string;
    pais?: string;
    idPaisResidencia?: string;
    idEmpresa?: any;
    idConvenio?: any;
  }> {
    return databases.getDocument(this.DATABASE_NAME, this.collectionId, idDocument)
      .then(paciente => ({
        $id: paciente.$id,
        nombres: paciente.nombres,
        apellidos: paciente.apellidos,
        pais: paciente.pais,
        idPaisResidencia: paciente.idPaisResidencia,
        idEmpresa: paciente.idEmpresa,
        idConvenio: paciente.idConvenio
      }));
  }
  

  /**
   *getDocumentActive
   * @returns
   */
  getDocumentActive(): Promise<Paciente[]> {
    return databases.listDocuments<Paciente>(
      this.DATABASE_NAME,
      this.collectionId,
      [Query.equal('activo', true),]
    ).then(response => response.documents);
  }

    /**
   *getPacientesByDocument
   * @returns
   */
   getPacientesByDocument(identificacion: string): Promise<Paciente[]> {
    return databases.listDocuments<Paciente>(
      this.DATABASE_NAME,
      this.collectionId,
      [Query.equal('identificacion', identificacion),]
    ).then(response => response.documents);
  }

   /**
   *getPacientesByDocument
   * @returns
   */
   getPacientesByEmail(email: string): Promise<Paciente[]> {
    return databases.listDocuments<Paciente>(
      this.DATABASE_NAME,
      this.collectionId,
      [Query.equal('email', email),]
    ).then(response => response.documents);
  }


  EstadoCivilesService(idDocument: string) {
    return databases.getDocument(this.DATABASE_NAME, this.collectionId, idDocument);
  }


  /**
 * @createDocument()
 * @param data
 * @returns
 */
  createTest(data) {
    return databases.createDocument(this.DATABASE_NAME, 'historia_clinica', ID.unique(), data);
  }


  // Insertar tutor

  createTutor(data) {
    return databases.createDocument(this.DATABASE_NAME, 'pacientes_contactos', ID.unique(), data);
  }

  getTutores(idPaciente: string) {
    return databases.listDocuments(this.DATABASE_NAME, 'pacientes_contactos', [Query.equal('idPaciente', [idPaciente]),]);
  }

  deleteTutor(documentId: string) {
    return databases.deleteDocument(this.DATABASE_NAME, 'pacientes_contactos', documentId);
  }


    //Observaciones collecion pacientes_observaciones

    createObservaciones(data) {
      return databases.createDocument(this.DATABASE_NAME, 'pacientes_observaciones', ID.unique(), data);
    }

    getObservaciones(idPaciente: string) {
      return databases.listDocuments(this.DATABASE_NAME, 'pacientes_observaciones', [Query.equal('idPaciente', [idPaciente]),]);
    }

    deleteObservaciones(documentId: string) {
      return databases.deleteDocument(this.DATABASE_NAME, 'pacientes_observaciones', documentId);
    }


    // GRUPO FAMILIAR
    // Buscar el documento del paciente que está en el grupo familiar Y también todos los que están en el campo docGrupoFamiliar

    getGrupoFamiliar(idPaciente: string) {
      return databases.listDocuments(this.DATABASE_NAME, this.collectionId, [Query.equal('docGrupoFamiliar', [idPaciente]),]);


    }


}
